import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Lock, TrendingUp } from 'lucide-react';

const API_URL = (process.env.REACT_APP_BACKEND_URL || '') + '/api';

// A public "locked premium preview" — shows a real upcoming fixture but hides
// the AI pick behind a blur + trial CTA. Renders nothing until data loads.
export const LockedPreview = () => {
  const navigate = useNavigate();
  const [cfg, setCfg] = useState(null);
  const [teaser, setTeaser] = useState(null);

  useEffect(() => {
    axios.get(`${API_URL}/growth/site-config`).then((r) => setCfg(r.data)).catch(() => {});
    axios.get(`${API_URL}/growth/teaser`).then((r) => r.data.available && setTeaser(r.data)).catch(() => {});
  }, []);

  if (!teaser || (cfg && cfg.locked_preview_enabled === false)) return null;
  const when = String(teaser.match_date || '').slice(0, 10);

  return (
    <div className="max-w-md mx-auto my-8 rounded-2xl border border-emerald-500/25 bg-[#0c1220] overflow-hidden" data-testid="locked-preview">
      <div className="px-5 pt-5 pb-3">
        <div className="flex items-center gap-2 text-emerald-400 text-[11px] font-bold uppercase tracking-wider mb-2">
          <TrendingUp className="w-3.5 h-3.5" /> AI Pick of the Day
        </div>
        <div className="text-lg font-black text-white">{teaser.home_team} <span className="text-zinc-500">vs</span> {teaser.away_team}</div>
        <div className="text-xs text-zinc-500 mt-1">{teaser.competition} · {when}</div>
      </div>
      <div className="relative px-5 pb-5">
        <div className="rounded-xl bg-black/40 p-4 select-none" style={{ filter: 'blur(6px)' }} aria-hidden="true">
          <div className="text-sm text-zinc-300">Predicted result: <b className="text-emerald-400">Home Win</b></div>
          <div className="text-sm text-zinc-300 mt-1">Scoreline: <b className="text-white">2-1</b> · Confidence {teaser.confidence}%</div>
          <div className="text-sm text-zinc-300 mt-1">Value pick: <b className="text-emerald-400">Over 2.5 goals</b></div>
        </div>
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-2">
          <div className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-emerald-500/20 backdrop-blur">
            <Lock className="w-5 h-5 text-emerald-400" />
          </div>
          <button onClick={() => navigate('/register?plan=pro&trial=1')} data-testid="locked-preview-cta"
            className="px-5 py-2.5 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white text-sm font-bold transition-colors">
            Unlock free for 14 days
          </button>
        </div>
      </div>
    </div>
  );
};
